export const config = {

    apiUrl: '/api',
    baseUrl: '',
    imageUrl: '/storage',


    // apiUrl: 'http://127.0.0.1:8000/api',
    // imageUrl: 'http://127.0.0.1:8000/storage',
    // videoUrl: 'http://127.0.0.1:8000/storage'

    // apiUrl: 'https://bcsapi.danialdigitalacademy.com/api',
    // baseUrl: 'https://bcsapi.danialdigitalacademy.com/',
    // imageUrl: 'https://bcsapi.danialdigitalacademy.com/storage',
    // videoUrl: 'https://bcsapi.danialdigitalacademy.com/storage',
    // webUrl: 'https://bcs.danialdigitalacademy.com',
};
